import { GuideType, InteractiveComponents } from '../../../core/enums';
import { Locale, LocaleKeys } from '../../../core/locale';
import { ScreenTaskControllerTypes } from '../../../core/navigation/ScreenTaskControllerTypes';
import {
    EmptyGuideChannelOptionsOverlayActions,
    EmptyOneLineGuideChannelOptionsOverlayActions,
} from '../../overlay/channeloptionsoverlay/channeloptionsoverlay.enum';
import {
    channelOptionsOverlayApplyFilter,
    GLOBAL_MOUSE_TRAP,
    showGuideOptionsOverlay,
    userHasSelectedCategoryFilter,
} from '../../overlay/channeloptionsoverlay/channeloptionsoverlay.reducers';
import { onKeyOkExitConfirmationOverlay } from '../../overlay/exitconfirmationoverlay/exitconfirmationoverlay.reducers';
import { setOverlayHighlightVerticalPositionAction } from '../../overlay/overlayhighlight/overlayhighlight.actions';
import {
    hideOverlayDialog,
    onKeyDownOverlayDialog,
    onKeyLeftOverlayDialog,
    onKeyRightOverlayDialog,
    onKeyUpOverlayDialog,
    onMouseOutOverlayDialogOperations,
    onMouseOverOverlayDialogOperations,
} from '../../overlaydialog/overlaydialog.reducers';
import { showEmptyGuideScreen, showGuideScreen } from '../../screens/screens.reducers';
import {
    hideSidebarNavigationMenu,
    showSidebarNavigationMenu,
} from '../../sidebarnavigationmenu/sidebarnavigationmenu.reducers';
import { hideOneLineGuide } from '../../videoplayerui/onelineguide/onelineguide.reducers';

export const onKeyOkEmptyGuide =
    (guideType: GuideType = GuideType.GRID_GUIDE) =>
    (dispatch: Function, getState: Function) => {
        const { verticalPosition, horizontalPosition } = getState().overlayHighlight;
        const { horizontalSelectionOptions } = getState().channelOptionsOverlay;
        const { screenTaskController } = getState().screens;

        const categoriesFilterIndex =
            guideType === GuideType.GRID_GUIDE
                ? EmptyGuideChannelOptionsOverlayActions.CATEOGORIES_FILTER_PILL
                : EmptyOneLineGuideChannelOptionsOverlayActions.CATEOGORIES_FILTER_PILL;

        const channelsFilterIndex =
            guideType === GuideType.GRID_GUIDE
                ? EmptyGuideChannelOptionsOverlayActions.CHANNELS_FILTER_PILL
                : EmptyOneLineGuideChannelOptionsOverlayActions.CHANNELS_FILTER_PILL;

        const filterButtonIndex =
            guideType === GuideType.GRID_GUIDE
                ? EmptyGuideChannelOptionsOverlayActions.VIEW_GUIDE_WITH_SELECTED_FILTERS
                : EmptyOneLineGuideChannelOptionsOverlayActions.VIEW_GUIDE_WITH_SELECTED_FILTERS;

        const isFavoritesFilterAlreadySelected =
            horizontalSelectionOptions[horizontalPosition[channelsFilterIndex]] ===
            Locale.getString(LocaleKeys.GUIDE_CHANNEL_TYPES_FAVORITES);

        switch (screenTaskController) {
            case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
                dispatch(onKeyOkExitConfirmationOverlay());
                break;
            case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
                break;
            case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
                dispatch(hideOverlayDialog());
                break;
            case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY: {
                if (
                    guideType === GuideType.ONE_LINE_GUIDE &&
                    verticalPosition ===
                        EmptyOneLineGuideChannelOptionsOverlayActions.GO_TO_GRID_GUIDE
                ) {
                    dispatch(hideOneLineGuide());
                    dispatch(hideOverlayDialog());
                    dispatch(showEmptyGuideScreen());
                    return;
                }

                const userSelectedCategoryFilterValue = userHasSelectedCategoryFilter(
                    categoriesFilterIndex,
                    horizontalPosition,
                );

                if (verticalPosition === filterButtonIndex) {
                    if (isFavoritesFilterAlreadySelected && !userSelectedCategoryFilterValue) {
                        dispatch(hideOverlayDialog());
                        return;
                    }

                    dispatch(
                        channelOptionsOverlayApplyFilter(
                            categoriesFilterIndex,
                            channelsFilterIndex,
                        ),
                    );

                    if (userSelectedCategoryFilterValue) {
                        return;
                    }

                    if (guideType === GuideType.GRID_GUIDE) {
                        dispatch(showGuideScreen());
                    }

                    return;
                }
                dispatch(setOverlayHighlightVerticalPositionAction(filterButtonIndex));

                break;
            }
            default:
                break;
        }
    };

export const onLongKeyOkEmptyGuide =
    (guideType: GuideType = GuideType.GRID_GUIDE) =>
    (dispatch: Function, getState: Function) => {
        const { screenTaskController } = getState().screens;

        switch (screenTaskController) {
            case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
                dispatch(hideSidebarNavigationMenu());
                break;
            default:
                dispatch(showGuideOptionsOverlay(guideType));
                break;
        }
    };

export const onKeyUpEmptyGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyUpOverlayDialog());
            break;
        default:
            break;
    }
};

export const onKeyDownEmptyGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyDownOverlayDialog());
            break;
        default:
            break;
    }
};

export const onKeyRightEmptyGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onKeyRightOverlayDialog());
            break;
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(showEmptyGuideScreen());
            break;
        default:
            dispatch(hideSidebarNavigationMenu());
            break;
    }
};

export const onKeyLeftEmptyGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onKeyLeftOverlayDialog());
            break;
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(showEmptyGuideScreen());
            break;
        default:
            break;
    }
};

export const onKeyBackEmptyGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(hideOverlayDialog());
            dispatch(showSidebarNavigationMenu());
            return;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(hideOverlayDialog());
            dispatch(showEmptyGuideScreen());
            return;

        default:
            dispatch(hideOverlayDialog());
    }
};

export const onMouseOverEmptyGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    if (screenTaskController !== ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY) {
        return;
    }
    dispatch(onMouseOverOverlayDialogOperations());
};

export const onMouseOutEmptyGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    if (screenTaskController !== ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY) {
        return;
    }
    dispatch(onMouseOutOverlayDialogOperations());
};

export const onMouseClickEmptyGuide =
    (guideType = GuideType.GRID_GUIDE) =>
    (dispatch: Function, getState: Function) => {
        const {
            interactiveLayer: { activeComponent },
            inputFactory: { value },
            screens: { screenTaskController },
        } = getState();

        if (screenTaskController !== ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY) {
            return;
        }

        if (value === GLOBAL_MOUSE_TRAP) {
            dispatch(hideOverlayDialog());
            return;
        }

        if (activeComponent === InteractiveComponents.WEST) dispatch(onKeyLeftOverlayDialog());
        else if (activeComponent === InteractiveComponents.EAST)
            dispatch(onKeyRightOverlayDialog());
        else dispatch(onKeyOkEmptyGuide(guideType));
    };
